"use client";
import { motion } from "framer-motion";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation, Autoplay } from "swiper/modules";
import { useState } from "react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

const testimonials = [
  {
    name: "Rahul Mehra",
    feedback:
      "Salarymates helped me in a financial emergency. The loan was processed instantly and without hassle.",
    avatar: "/images/t1.webp",
    rating: 5,
    designation: "Software Engineer",
  },
  {
    name: "Ankita Joshi",
    feedback:
      "The whole process was digital and easy to understand. I received the loan amount in my bank in no time.",
    avatar: "/images/t3.webp",
    rating: 5,
    designation: "Marketing Manager",
  },
  {
    name: "Siddharth Kapoor",
    feedback:
      "Highly recommended for salaried professionals! Transparent terms and very professional support.",
    avatar: "/images/t2.webp",
    rating: 5,
    designation: "Financial Analyst",
  },
  {
    name: "Neha Sinha",
    feedback:
      "I was skeptical at first, but Salarymates exceeded my expectations. Smooth and quick!",
    avatar: "/images/t5.webp",
    rating: 4,
    designation: "HR Manager",
  },
  {
    name: "Manish Rawat",
    feedback:
      "Getting a short-term loan was never this easy. Kudos to the team at Salarymates!",
    avatar: "/images/t4.webp",
    rating: 5,
    designation: "Business Owner",
  },
 {
  name: "Priya Sharma",
  feedback:
    "Bahut badhiya customer service aur jaldi mil gaya. Colleagues ko bhi recommend karungi.",
  avatar: "/images/t6.webp",
  rating: 5,
  designation: "Teacher",
},
{
  name: "Rahul Verma",
  feedback:
    "Bohot fast process hai. Koi tension nahi, sab digitally ho gaya. 10/10 experience.",
  avatar: "/images/t7.webp",
  rating: 5,
  designation: "Software Engineer",
},
{
  name: "Neha Gupta",
  feedback:
    "Maine pehli baar use kiya, bohot easy laga. Support team bhi helpful thi.",
  avatar: "/images/t9.webp",
  rating: 5,
  designation: "Marketing Manager",
},
{
  name: "Amit Singh",
  feedback:
    "Sahi mein instant mil gaya. Paperwork ka koi jhanjhat nahi. Sab kuch online.",
  avatar: "/images/t8.webp",
  rating: 5,
  designation: "Banker",
},
];

const Testimonials = () => {
  const [swiperRef, setSwiperRef] = useState(null);
  const [imageErrors, setImageErrors] = useState({});

  const handleImageError = (name) => {
    setImageErrors(prev => ({ ...prev, [name]: true }));
  };

  const getAvatarUrl = (avatarPath, name) => {
    if (imageErrors[name]) {
      // Fallback to placeholder with initials
      const initials = name.split(' ').map(n => n[0]).join('');
      return `https://ui-avatars.com/api/?name=${encodeURIComponent(initials)}&background=2D5F7A&color=fff&size=128&bold=true&length=2`;
    }
    return avatarPath;
  };

  return (
    <section className="relative bg-[#0A1620] overflow-hidden py-20 lg:py-24">
      {/* Dark Theme Background */}
      <div className="absolute inset-0 bg-[#0A1620]"></div>

      {/* Premium Accent Gradients */}
      <div className="absolute top-40 right-0 w-[500px] h-[500px] bg-[#1B4D5E]/20 rounded-full blur-[120px]"></div>
      <div className="absolute bottom-40 left-0 w-[400px] h-[400px] bg-[#1A3B4D]/20 rounded-full blur-[100px]"></div>
      
      {/* Subtle Grid Pattern */}
      <div className="absolute inset-0 opacity-[0.02]">
        <div
          className="absolute inset-0"
          style={{
            backgroundImage: `linear-gradient(to right, #2D5F7A 1px, transparent 1px), linear-gradient(to bottom, #2D5F7A 1px, transparent 1px)`,
            backgroundSize: "60px 60px",
          }}
        ></div>
      </div>

      {/* Top Wave */}
      <svg
        className="absolute top-0 left-0 w-full h-48 rotate-180"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1440 320"
        preserveAspectRatio="none"
      >
        <path
          fill="#2D5F7A"
          fillOpacity="0.08"
          d="M0,192L48,176C96,160,192,128,288,128C384,128,480,160,576,176C672,192,768,192,864,176C960,160,1056,128,1152,128C1248,128,1344,160,1392,176L1440,192L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
        ></path>
      </svg>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header Section */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12 md:mb-16"
        >
          <motion.div
            initial={{ width: 0 }}
            whileInView={{ width: "80px" }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="h-0.5 bg-gradient-to-r from-[#7BC4E0] to-transparent mx-auto mb-6"
          />
         
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4">
            What Our <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#7BC4E0] to-[#4D9ABF]">Borrowers Say</span>
          </h2>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.4 }}
            className="text-base md:text-lg text-[#CCE6F5] max-w-2xl mx-auto"
          >
            Trusted by salaried professionals across India
          </motion.p>
        </motion.div>

        {/* Swiper Slider */}
        <div className="relative px-4 md:px-10">
          <Swiper
            onInit={(ev) => setSwiperRef(ev)}
            modules={[Pagination, Navigation, Autoplay]}
            spaceBetween={24}
            slidesPerView={1}
            breakpoints={{
              640: { slidesPerView: 1, spaceBetween: 20 },
              768: { slidesPerView: 2, spaceBetween: 24 },
              1024: { slidesPerView: 3, spaceBetween: 30 },
            }}
            pagination={{ 
              clickable: true,
              el: '.custom-pagination',
            }}
            navigation={{
              nextEl: '.custom-next',
              prevEl: '.custom-prev',
            }}
            autoplay={{
              delay: 5000,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }}
            loop={true}
            className="!pb-12"
          >
            {testimonials.map((t, idx) => (
              <SwiperSlide key={idx}>
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: idx * 0.1 }}
                  className="group h-full"
                >
                  <div className="relative bg-gradient-to-br from-[#1A2F3A] to-[#0F2128] rounded-2xl border border-[#2D5F7A]/30 p-6 h-full hover:border-[#7BC4E0]/30 transition-all duration-500 hover:shadow-xl hover:shadow-[#7BC4E0]/5">
                    
                    {/* Quote Icon */}
                    <div className="absolute top-4 right-4 text-4xl text-[#2D5F7A]/20 select-none">"</div>
                    
                    {/* Avatar and Rating */}
                    <div className="flex items-center gap-4 mb-4">
                      <div className="relative">
                        <div className="w-16 h-16 rounded-full overflow-hidden ring-2 ring-[#2D5F7A]/30 group-hover:ring-[#7BC4E0]/50 transition-all duration-300">
                          <img
                            src={getAvatarUrl(t.avatar, t.name)}
                            alt={t.name}
                            className="w-full h-full object-cover"
                            onError={() => handleImageError(t.name)}
                          />
                        </div>
                        <div className="absolute -bottom-1 -right-1 w-5 h-5 bg-[#2D5F7A] rounded-full flex items-center justify-center border-2 border-[#0A1620]">
                          <span className="text-white text-xs">✓</span>
                        </div>
                      </div>
                      <div>
                        <h4 className="text-white font-semibold text-lg group-hover:text-[#7BC4E0] transition-colors">
                          {t.name}
                        </h4>
                        <p className="text-[#8FAFC7] text-sm">{t.designation}</p>
                        {/* Star Rating */}
                        <div className="flex gap-1 mt-1">
                          {[...Array(5)].map((_, i) => (
                            <svg
                              key={i}
                              className={`w-4 h-4 ${
                                i < t.rating ? 'text-[#7BC4E0]' : 'text-[#2D5F7A]/30'
                              }`}
                              fill="currentColor"
                              viewBox="0 0 20 20"
                            >
                              <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                            </svg>
                          ))}
                        </div>
                      </div>
                    </div>

                    {/* Feedback */}
                    <p className="text-[#CCE6F5] text-sm leading-relaxed italic relative z-10">
                      "{t.feedback}"
                    </p>

                    {/* Bottom Accent Line */}
                    <motion.div
                      initial={{ scaleX: 0 }}
                      whileInView={{ scaleX: 1 }}
                      viewport={{ once: true }}
                      transition={{ delay: 0.5, duration: 0.5 }}
                      className="absolute bottom-0 left-6 right-6 h-0.5 bg-gradient-to-r from-[#7BC4E0] to-transparent origin-left"
                    />
                  </div>
                </motion.div>
              </SwiperSlide>
            ))}
          </Swiper>

          {/* Custom Navigation Buttons */}
          <button className="custom-prev absolute left-0 top-1/2 -translate-y-1/2 z-20 w-10 h-10 md:w-12 md:h-12 bg-gradient-to-br from-[#1A2F3A] to-[#0F2128] rounded-full border border-[#2D5F7A]/30 flex items-center justify-center text-white hover:border-[#7BC4E0]/50 hover:scale-110 transition-all duration-300 disabled:opacity-30 disabled:cursor-not-allowed">
            <svg className="w-5 h-5 md:w-6 md:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
          </button>
          <button className="custom-next absolute right-0 top-1/2 -translate-y-1/2 z-20 w-10 h-10 md:w-12 md:h-12 bg-gradient-to-br from-[#1A2F3A] to-[#0F2128] rounded-full border border-[#2D5F7A]/30 flex items-center justify-center text-white hover:border-[#7BC4E0]/50 hover:scale-110 transition-all duration-300 disabled:opacity-30 disabled:cursor-not-allowed">
            <svg className="w-5 h-5 md:w-6 md:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </button>
        </div>

        {/* Simple Pagination Dots */}
        <style jsx>{`
          .custom-pagination {
            display: flex;
            justify-content: center;
            gap: 8px;
            margin-top: 24px;
          }
          .custom-pagination .swiper-pagination-bullet {
            width: 8px;
            height: 8px;
            background: #2D5F7A;
            opacity: 0.3;
            border-radius: 50%;
            cursor: pointer;
            transition: all 0.3s ease;
          }
          .custom-pagination .swiper-pagination-bullet-active {
            background: #7BC4E0;
            opacity: 1;
            width: 24px;
            border-radius: 4px;
          }
        `}</style>
        <div className="custom-pagination"></div>

        {/* Trust Badge */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.5 }}
          className="flex items-center justify-center gap-2 mt-10"
        >
          <div className="flex -space-x-2">
            {[1, 2, 3, 4].map((i) => (
              <div key={i} className="w-8 h-8 rounded-full bg-gradient-to-br from-[#2D5F7A] to-[#1E3B4A] border-2 border-[#0A1620] flex items-center justify-center">
                <span className="text-[#CCE6F5] text-xs font-bold">✓</span>
              </div>
            ))}
          </div>
          <span className="text-[#8FAFC7] text-sm ml-2">Trusted by salaried professionals across India</span>
        </motion.div>
      </div>

      {/* Bottom Wave */}
      <div className="absolute bottom-0 left-0 w-full overflow-hidden pointer-events-none">
        <svg
          className="relative block w-full h-16 md:h-20"
          viewBox="0 0 1440 120"
          preserveAspectRatio="none"
        >
          <path
            fill="#2D5F7A"
            fillOpacity="0.08"
            d="M0,64 C240,96 480,32 720,32 C960,32 1200,96 1440,64 L1440,120 L0,120 Z"
          />
        </svg>
      </div>
    </section>
  );
};

export default Testimonials;